import { render, staticRenderFns } from "./TradeRequestManageResponse.vue?vue&type=template&id=cb4c0146"
import script from "./TradeRequestManageResponse.vue?vue&type=script&lang=js"
export * from "./TradeRequestManageResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports